import { FAIcon } from "./faIcon.js";
import { Helper } from "../util/helper.js";
import { MenuEntry } from "./menu.js";
import React from "react";
export class ObjectContextMenu extends React.Component<ObjectContextMenuProps, ObjectContextMenuState>{
    private _menuRef: HTMLDivElement = null;


    constructor(props: ObjectContextMenuProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }


    private _setMenuRef = (r: HTMLDivElement) => {
        this._menuRef = r;
    }

    private _toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    private _onEntryClick = (entry: ObjectContextMenuEntry) => {
        this.props.onSelect(entry);
    }

    private _isEntryVisible = (entry: MenuEntry): boolean => {
        if (typeof entry.show === "boolean") {
            return entry.show;
        }

        if (this.props.enableMenuItem)
            return this.props.enableMenuItem(entry.show);
    }
    private _renderEntry = (entry: ObjectContextMenuEntry) => {
        const rendered = this._isEntryVisible(entry) ?

            <div className={Classes.ContextMenuEntry} key={entry.id} onClick={e => this._onEntryClick(entry)} style={this.props.menuItemStyle}>
                {
                    Helper.hasValue(entry.icon) ?
                        <FAIcon name={entry.icon} style={{ marginRight: "5px" }} />
                        : null
                }
                {entry.text}
            </div> : null;

        return (rendered);
    }

    private _onExternalClick = (e: MouseEvent) => {
        if (this.state.isOpen && this._menuRef && !this._menuRef.contains(e.target as Node)) {
            this.setState({ isOpen: false });
        }
    }


    componentDidMount() {
        window.addEventListener("click", this._onExternalClick);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this._onExternalClick);
    }

    render() {
        return (
            <div
                ref={this._setMenuRef}
                className={`${Classes.ContextMenu} ${this.state.isOpen ? Classes.ContextMenuOpen : ""} ${this.props.alignLeft ? Classes.ContextMenuLeftAlign : ""}`}
            >
                <div onClick={this._toggle} className={Classes.ContextMenuEllipsis} style={this.props.toggleStyle}>
                    <FAIcon name="ellipsis-v" attributes={["2x"]} />
                </div>
                {
                    this.state.isOpen ?
                        <div className={Classes.ContextMenuEntries} style={this.props.menuStyle}>
                            {
                                this.props.entries.map(this._renderEntry)
                            }
                        </div>
                        : null
                }
            </div>
        );
    }
}

enum Classes {
    ContextMenu = "e-context-menu",
    ContextMenuOpen = "e-context-menu--open",
    ContextMenuEllipsis = "e-context-menu__trigger",
    ContextMenuEntries = "e-context-menu__entries",
    ContextMenuEntry = "e-context-menu__entry",
    ContextMenuLeftAlign = "e-context-menu--left-align"
}


export interface ObjectContextMenuProps {
    entries: Array<ObjectContextMenuEntry>;
    onSelect: (entry: ObjectContextMenuEntry) => void;
    alignLeft?: boolean;
    toggleStyle?: React.CSSProperties;
    menuStyle?: React.CSSProperties;
    menuItemStyle?: React.CSSProperties;
    enableMenuItem?(action: string | boolean, prepare?: any);
}

export interface ObjectContextMenuEntry {
    text: string;
    id: string;
    icon?: string;
    show?: string | boolean;
}

interface ObjectContextMenuState {
    isOpen: boolean;
}